<div class="w-full h-full">
    <div class="px-8">
        <form [formGroup]="updateForm">
            <div class="grid grid-cols-12 gap-3 pl-2 pr-2 mt-6">
                <!-- Biller Name -->
                <div class="col-span-3 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-110-px font-semibold">
                            Biller Name:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="billerName" 
                            type="text" 
                            placeholder="Biller Name">
                    </div>
                </div>

                <!-- Biller Category -->
                <div class="col-span-3 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <div class="flex items-center space-x-3">
                            <span class="text-xs w-120-px font-semibold">
                                Biller Category:
                            </span>
                            <app-dropdown-field
                                [options]="billerCategoryOptions"
                                [selectedText]="billerCategory_text"
                                placeholder="== Select an option =="
                                (selectionChange)="setBillerCategory($event.label, $event.value)"
                            ></app-dropdown-field>
                        </div>
                    </div>
                </div>

                <!-- Biller Description -->
                <div class="col-span-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <div class="text-xs w-180-px font-semibold">
                            Biller Description:
                        </div>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="billerDescription" 
                            type="text" 
                            placeholder="Enter Description">
                    </div>
                </div>

                <!-- Biller Image -->
                <div class="col-span-3">
                    <div class="card-input flex items-center justify-between text-xs py-2 w-full">
                        <div class="text-xs w-80-px font-semibold">
                            Biller Image:
                        </div>
                        <div class="flex flex-row gap-1">
                            <input formControlName="image" 
                                type='file' 
                                class="hidden" 
                                (change)="onSelectFile($event)" 
                                #coverImg 
                                accept="image/*">
                            
                            <button 
                                type="button" 
                                class="flex items-center justify-center uppercase custom-btn font-semibold h-30-px px-3 py-1 focus:outline-none" 
                                [ngClass]="imageFile ? 'bg-white b-orange orange-text font-bold' : 'btn-dark-orange'"
                                (click)="coverImg.click()">
                                <span *ngIf="imageFile" class="material-icons orange-text text-sm mr-2">
                                    upload
                                </span>
                                {{ !imageFile ? 'Upload' : 'Reupload' }}
                            </button>
                            
                            <!-- View newly uploaded image -->
                            <button 
                                type="button" 
                                *ngIf="imageFile" 
                                class="flex items-center justify-center uppercase btn-dark-orange custom-btn font-semibold h-30-px px-3 py-1 focus:outline-none" 
                                (click)="viewUploadedImage()">
                                View
                                <span class="material-icons text-white text-sm ml-2">
                                    visibility
                                </span>
                            </button>
                            
                            <!-- View existing image -->
                            <button 
                                type="button" 
                                *ngIf="existingImageUrl && !imageFile" 
                                class="flex items-center justify-center uppercase btn-dark-orange custom-btn font-semibold h-30-px px-3 py-1 focus:outline-none" 
                                (click)="openSite(existingImageUrl)">
                                Current
                                <span class="material-icons text-white text-sm ml-2">
                                    visibility
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
                
                <!-- First Field Name & Second Field Name -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <span class="text-xs w-190-px font-semibold">
                            First Field Name:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="firstFieldName" 
                            type="text" 
                            placeholder="Field Name">
                    </div>
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mt-6">
                        <span class="text-xs w-190-px font-semibold">
                            Second Field Name:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="secondFieldName" 
                            type="text" 
                            placeholder="Field Name">
                    </div>
                </div>

                <!-- First Field Format & Second Field Format - REUSABLE DROPDOWNS -->
                <div class="col-span-4 mb-3">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <div class="flex items-center space-x-3">
                            <span class="text-xs w-100-px font-semibold">
                                First Field Format:
                            </span>
                            <app-dropdown-field
                                [options]="fieldFormatOptions"
                                [selectedText]="firstFieldFormat_text"
                                placeholder="== Select an option =="
                                (selectionChange)="setFirstFieldFormat($event.label, $event.value)"
                            ></app-dropdown-field>
                        </div>
                    </div>
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mt-6">
                        <div class="flex items-center">
                            <span class="text-xs w-116-px font-semibold">
                                Second Field Format:
                            </span>
                            <app-dropdown-field
                                [options]="fieldFormatOptions"
                                [selectedText]="secondFieldFormat_text"
                                placeholder="== Select an option =="
                                (selectionChange)="setSecondFieldFormat($event.label, $event.value)"
                            ></app-dropdown-field>
                        </div>
                    </div>
                </div>

                <!-- First & Second Field Max Length -->
                <div class="col-span-4 mb-1">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-300-px font-semibold">
                            First Field Max Length:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="firstFieldWidth"
                            appOnlyNumber 
                            type="number" 
                            placeholder="Length">
                    </div>
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full mt-6">
                        <span class="text-xs w-300-px font-semibold">
                            Second Field Max Length:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="secondFieldWidth"  
                            appOnlyNumber
                            type="number" 
                            placeholder="Length">
                    </div>
                </div>

                <!-- Convenience Fee -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-140-px font-semibold">
                            Convenience Fee:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            appOnlyNumber
                            [allowDecimal]="true" 
                            formControlName="convenienceFee" 
                            type="number" 
                            placeholder="Enter Convenience Fee">
                    </div>
                </div>

                <!-- Service Fee Percentage -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-280-px font-semibold">
                            Service Fee Percentage (%):
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="serviceFeePercentage" 
                            type="number" 
                            appOnlyNumber 
                            [allowDecimal]="true" 
                            placeholder="Applied as percentage of the bill amount (0-100)">
                    </div>
                </div>

                <!-- Service Fee Fixed -->
                <div class="col-span-4">
                    <div [appHighlightOnActive]="" class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-170-px font-semibold">
                            Service Fee Fixed:
                        </span>
                        <input class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="serviceFeeFixed" 
                            type="number" 
                            appOnlyNumber 
                            [allowDecimal]="true" 
                            placeholder="Service Fee">
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="col-span-12 mt-5">
                    <div class="w-full h-full flex items-end justify-center">
                        <button 
                            (click)="update()" 
                            [disabled]="isSubmitDisabled()"
                            [ngClass]="{'opacity-50 cursor-not-allowed': isSubmitDisabled()}"
                            class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2"
                            [title]="updateForm.invalid ? 'Please fill in all required fields' : (isSubmitDisabled() ? 'No changes to save' : 'Save changes')">
                            submit
                        </button>
                        <button 
                            (click)="cancel()" 
                            class="uppercase custom-btn btn-red font-semibold text-xs px-6 py-2 ml-2">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>